var _this = this,
  _jsxFileName = "/builds/EgNbCExi/0/ramsey-solutions/ramsey-plus/survey-ui/src/components/InputCheckbox/InputCheckbox.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable no-extra-parens */
import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
var InputCheckbox = function InputCheckbox(_ref) {
  var id = _ref.id,
    label = _ref.label,
    props = _objectWithoutProperties(_ref, ["id", "label"]);
  return /*#__PURE__*/React.createElement("span", {
    className: "survey-InputCheckbox",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(Field, Object.assign({
    className: "survey-InputCheckbox-input",
    id: id,
    type: "checkbox",
    "data-testid": "Input"
  }, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 5
    }
  })), /*#__PURE__*/React.createElement("label", {
    className: "survey-InputCheckbox-label",
    htmlFor: id,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 5
    }
  }, label));
};
InputCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};
export { InputCheckbox as default };